import { render, staticRenderFns } from "./editorial-slider.vue?vue&type=template&id=eec0a286&scoped=true&"
import script from "./editorial-slider.vue?vue&type=script&lang=js&"
export * from "./editorial-slider.vue?vue&type=script&lang=js&"
import style0 from "./editorial-slider.vue?vue&type=style&index=0&id=eec0a286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec0a286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('eec0a286', component.options)
    } else {
      api.reload('eec0a286', component.options)
    }
    module.hot.accept("./editorial-slider.vue?vue&type=template&id=eec0a286&scoped=true&", function () {
      api.rerender('eec0a286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/editorial-slider.vue"
export default component.exports